import { codeSplit } from 'bernie-core';

export interface EntryFormProps {
    module: string;
    uniquekey: string;
    questions: any;
    primaryColour: string;
    secondaryColour: string;
    campaign_name: string;
    context: any;
    sweepstakesEndCopy?: string;
    competitionEndCopy?: string;
    successEntryTitle?: string;
    successEntryCopy?: string;
    successEntryCtaText?: string;
    successEntryCtaUrl?: string;
    styleOverrides?: any;
    cTAText?: string;
    cTATextColor?: string;
    cTAColor?: string;
    formElementBackgroundColor?: string;
    textColor?: string;
    formElementPlaceholderTextColor?: string;
    formElementTextColor?: string;
    backgroundImage?:string;
    turnOffReCAPTCHA?: string;
    scrollToTop?(): void;
    onEntryFormChange?(): void;
    setFormSubmitted?(value: boolean): void;
    isQuiz?: boolean;
  }

  export interface ReCaptchaValidation {
    captcha_key: boolean | string;
    ggCaptchaExpired?: boolean;
    ggCaptchaErrorMsg?: string;
    ggValidateCaptcha?: string;
  }

export const V3BreakerCompetitionModuleMap = codeSplit(() => import(/* webpackChunkName: "V3BreakerCompetitionModuleMap" */ '../components/v3-breaker-competition-module') as any);